<template>
  <mdb-container :class="topClass">
    <div v-if="currentGroup && !systemImages">
      <banner-small :group="currentGroup" title="Image Library"/>
    </div>
    <div v-if="systemImages">
      <h3>System Images</h3>
    </div>

    <div class="text-left">
      <mdb-card class="mb-4">
        <mdb-card-header>
          <mdb-breadcrumb class="breadcrumb-with-arrows">
            <mdb-breadcrumb-item v-for="(bc,i) in breadcrumbs" :key="i">
              <span v-if="breadcrumbs.length == i+1">{{ bc.name }}</span>
              <a v-if="i+1 < breadcrumbs.length" href="" @click.prevent="folderNavUp(bc)">{{ bc.name }}</a>
            </mdb-breadcrumb-item>
          </mdb-breadcrumb>
        </mdb-card-header>
        <mdb-card-body>

          <mdb-btn v-if="!(currentFolder.id == 0 && currentFolder.name=='Trash')" color="success"
                   icon="folder-plus"
                   size="sm"
                   @click="createModal = true">New Folder
          </mdb-btn>

          <mdb-btn v-if="images.length==0 && folders.length == 0 && currentFolder.id !=0"
                   color="danger" icon="trash"
                   size="sm" @click="deleteFolder">Delete Folder
          </mdb-btn>
          <mdb-btn v-if="currentFolder.id !=0"
                   icon="folder-tree"
                   size="sm" @click="moveFolder()">Move Folder
          </mdb-btn>
          <mdb-btn v-if="currentFolder.id != 0" size="sm" @click="renameModal = true">
            <mdb-icon icon="pencil-alt"/>
            Rename Folder
          </mdb-btn>


          <mdb-row>
            <mdb-col v-for="folder in folders" v-bind:key="folder.id" md="4">
              <a role="button" @click="loadFolders(folder)">
                <mdb-icon v-if="folder.id != 0 && !folder.isNew" far icon="folder" size="2x"/>
                <mdb-icon v-if="folder.isNew" color="success" far icon="folder" size="2x"/>
                <mdb-icon v-if="folder.id == 0 && folder.name == 'Trash'" color="danger" far icon="trash" size="2x"/>
                <span v-if="folder.isNew" class="text-success">{{ folder.name }}</span>
                <span v-if="!folder.isNew">{{ folder.name }}</span>

              </a>
            </mdb-col>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>
    </div>
    <div>
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h3>Images</h3>
        </mdb-card-header>
        <mdb-card-body>
          <div v-if="currentFolder.id == 0 && currentFolder.name == 'Trash'" class="text-danger">
            Images in the trash folder remain here for a <i>maximum</i> of 15 minutes.
            Move any images you wish to retain immediately to avoid permanent deletion.
          </div>
          <mdb-row>
            <mdb-col md="12">
              <div class="text-left">
                <mdb-btn v-if="!showUpload && !(currentFolder.id==0 && currentFolder.name=='Trash')" size="sm"
                         @click.native="showUpload=true">
                  <mdb-icon icon="image"/>
                  Upload New Image(s)
                </mdb-btn>
                <mdb-btn v-if="showUpload" size="sm" @click.native="showUpload=false">
                  <mdb-icon icon="times-circle"/>
                  Cancel Upload
                </mdb-btn>
                <mdb-btn v-if="images.length >1" icon="check" size="sm" @click="selectAll">Select All</mdb-btn>
                <mdb-btn v-if="images.length >1" icon="minus-circle" size="sm" @click="deSelectAll">Select None
                </mdb-btn>
                <mdb-btn v-if="images.length >0" :disabled="!anyImagesSelected" icon="folder-tree" size="sm"
                         @click="moveAllSelected">Move AlL Selected
                </mdb-btn>
                <mdb-btn v-if="!(currentFolder.id == 0 && currentFolder.name == 'Trash') && images.length>0" :disabled="!anyImagesSelected"
                         color="danger" icon="trash" size="sm" @click="deleteSelected">Delete AlL Selected
                </mdb-btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row v-if="showUpload" class="mb-4 mt-2">
            <mdb-col col="12">
              <mdb-btn v-if="readyToUpload && !uploading" color="success" icon="images" @click="uploadPhotos">Upload Now
              </mdb-btn>
              <mdb-file-upload :disabled="uploading" :files="files" multiple @change="handleChange"/>
              <div class="small">Max Size is 8MB</div>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col v-for="image in images" v-bind:key="image.id" md="3">
              <mdb-card class="mb-4">
                <mdb-view class="zoom">
                  <a target="_blank" v-bind:href="image.url">
                    <mdb-card-image :src="image.thumb"></mdb-card-image>
                    <mdb-mask overlay="white-slight" waves>
                      <mdb-badge v-if="currentGroup && image.id == currentGroup.avatarId" color="secondary" top>Group
                        Avatar
                      </mdb-badge>
                    </mdb-mask>
                  </a>
                </mdb-view>

                <mdb-card-body class="no-padding">

                  <mdb-tooltip v-if="!systemImages && !image.includeInSlideshow && currentGroup &&  currentGroup.role=='Admin'"
                               :options="{placement: 'top'}"
                               material
                               trigger="hover">
                    <span slot="tip">Add to Group Slideshow</span>
                    <mdb-btn slot="reference" floating size="sm" tag="a"
                             type="" color="success"
                             @click="toggleSlideshow(image)">
                      <mdb-icon icon="images" />
                    </mdb-btn>
                  </mdb-tooltip>

                  <mdb-tooltip v-if="!systemImages && image.includeInSlideshow && currentGroup && currentGroup.role=='Admin'"
                               :options="{placement: 'top'}"
                               material
                               trigger="hover">
                    <span slot="tip">Remove from Group Slideshow</span>
                    <mdb-btn slot="reference" floating size="sm"
                             tag="a"  color="warning"
                             type="" @click="toggleSlideshow(image)">
                      <mdb-icon icon="images"/>
                    </mdb-btn>
                  </mdb-tooltip>
                  <mdb-tooltip v-if="!systemImages && currentGroup && image.id != currentGroup.avatarId && currentGroup.role=='Admin'"
                               :options="{placement: 'top'}" material
                               trigger="hover">
                    <span slot="tip">Make Group Avatar</span>
                    <mdb-btn slot="reference" color="secondary" floating size="sm"
                             tag="a"
                             type="" @click="makeAvatar(image)">
                      <mdb-icon icon="star"/>
                    </mdb-btn>
                  </mdb-tooltip>
                  <mdb-tooltip v-if="(currentGroup && currentGroup.role=='Admin') || systemImages"
                               :options="{placement: 'top'}" material
                               trigger="hover">
                    <span slot="tip">Edit tags and caption.</span>
                    <mdb-btn slot="reference" color="success" floating size="sm"
                             tag="a"
                             type="" @click="editMeta(image)">
                      <mdb-icon icon="pencil"/>
                    </mdb-btn>
                  </mdb-tooltip>

                  <div class="top-actions">
                    <mdb-input class="cust-check" :id="'checkbox-'+image.id" v-model="image.selected" type="checkbox"/>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
          </mdb-row>
        </mdb-card-body>


        <mdb-card-footer v-if="systemImages && currentFolder.id != 0 && currentFolder.name != 'Trash'">
          <div v-if="currentFolder.allowPublicListing">
            This folder allows public API listing via {{backendUrl}}/api/v1/imageFolder/publicList/{{currentFolder.id}}
            <a href="" @click.prevent="togglePublicAccess">Disallow</a>
          </div>
          <div v-if="!currentFolder.allowPublicListing">
            This folder does not allow public API listing.
            <a href="" @click.prevent="togglePublicAccess">Allow</a>
          </div>
        </mdb-card-footer>
      </mdb-card>
    </div>

    <mdb-modal :show="createModal" class="text-center" size="lg" @close="createModal=false">
      <mdb-modal-header :close="true" center class="primary-color text-white">
        <h3 class="heading">New Folder</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input id="newFolderName" v-model="newFolderName" active label="Name"  @keydown.native="handleCreateKeyDown"/>
        <mdb-btn @click="createFolder">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal v-if="showMetaModal" class="text-center" size="md" @close="showMetaModal=false">
      <mdb-modal-header :close="true" center class="primary-color text-white">
        <h3 class="heading">Image Caption & Tags</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="workingMeta.caption" active label="Caption"/>
        <label>Tags</label>
        <cust-chip-input :chips="workingMeta.tags" />
        <mdb-btn @click="saveMeta" icon="save" size="sm" color="success">Save</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="renameModal" class="text-center" size="lg" @close="renameModal=false">
      <mdb-modal-header :close="true" center class="primary-color text-white">
        <h3 v-if="currentFolder" class="heading">Rename {{ currentFolder.name }} </h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input id="renameFolderName" v-model="newFolderName" active label="New Name" @keydown.native="handleRenameKeyDown"/>
        <mdb-btn @click="renameFolder">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="showMoveFolder" scrollable size="lg" @close="showMoveFolder=false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        <h5>Move to....</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <image-folder-navigator :group="systemImages ? null : currentGroup"
                                :exclude-folder="currentFolder"
                                select-label="Move to"
                                allow-root folders-only @selectedFolder="moveToFolder"/>

      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal v-if="showDeleteModal" @no="showDeleteModal=false" @yes="doDeleteSelected"/>

  </mdb-container>

</template>
<script>
import draggable from "vuedraggable"
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import error from '../common/Error'
import mdbFileUpload from 'mdbvue-file-upload'
import Vue from 'vue';
import ImageFolderNavigator from "../common/ImageFolderNavigator";
import YesNoModal from "../common/YesNoModal";
import {custChipInput} from "../common/CustChipInput";

import {
  mdbBadge,
  mdbBreadcrumb,
  mdbBreadcrumbItem,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';
import store from "../../store";

export default {
  name: "image-library",
  display: "Image Library",
  order: 1,
  watch: {
    createModal: function (n, o) {
      if (n) {
        Vue.nextTick().then(function () {
          let el = document.getElementById("newFolderName")
          if (el) el.focus()
        })
      }
    },
    renameModal: function (n, o) {
      if (n) {
        Vue.nextTick().then(function () {
          let el = document.getElementById("renameFolderName")
          if (el) el.focus()
        })
      }
    }
  },
  components: {
    mdbContainer,
    mdbBtn,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    mdbRow,
    mdbCol,
    mdbListGroup,
    mdbListGroupItem,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileUpload,
    draggable,
    bannerSmall,
    error,
    ImageFolderNavigator,
    YesNoModal,
    custChipInput
  },
  computed: {
    backendUrl() {
      return process.env.BACKEND_URL
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    anyImagesSelected() {
      for (let i of this.images) {
        if (i.selected) return true
      }
    },
    settings() {
      return this.$store.state.settings
    }
  },

  mounted() {
    document.title = "Images"
    if (this.$route.path.substring(0, 7) == "/group/") {
      api.groupBasics(this.$route.params.id, "organizer")
    }

    if (this.$route.path.substring(0, 7) == "/admin/") {
      this.systemImages = true
      this.topClass = "gp-has-header"
      store.dispatch("setCurrentGroup", null);

    }
    this.loadFolders(null)

  },
  data() {
    return {
      folders: [],
      images: [],
      error: null,
      currentFolder: {id: 0, name: "Top"},
      hasTrash: false,
      createModal: false,
      topClass: "",
      renameModal: false,
      showUpload: false,
      newFolderName: "",
      showMoveFolder: false,
      moveCandidates: [],
      moveAllSelectedImages: false,
      uploading: false,
      readyToUpload: false,
      files: [],
      gotError: false,
      systemImages: false,
      breadcrumbs: [],
      workingMeta: null,
      showMetaModal: false,
      showDeleteModal: false,

    };
  },
  methods: {
    selectAll() {
      for (let i of this.images) i.selected = true
    },
    deSelectAll() {
      for (let i of this.images) i.selected = false
    },
    folderNavUp(folder) {
      this.currentPresentation = null
      this.pages = []
      this.presentations = []
      this.loadFolders(folder)
    },

    loadFolders(folder) {
      this.folders = []
      this.images = []
      this.$store.dispatch("setExecuting", true)
      let url = "/imageFolder/list/"
      if (!this.systemImages) url += this.$route.params.id + "/"
      if (folder) {
        if (folder.id == 0 && folder.name == "Trash") url += "?folder=trash"
        else url += "/?folder=" + folder.id
      }
      api.get(url).then(
        (details) => {
          this.folders = details.data.folders
          this.images = details.data.images
          this.breadcrumbs = details.data.breadcrumbs
          if (folder) this.currentFolder = folder
          else {
            this.currentFolder = this.breadcrumbs[this.breadcrumbs.length-1]
          }
          if (details.data.deletedCount > 0 && this.folders) {
            this.folders.unshift({id: 0, name: "Trash"})
            this.hasTrash = true
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    handleRenameKeyDown(e) {
      if (e.keyCode === 13){
        this.renameFolder()
      }
    },
    handleCreateKeyDown(e) {
      if (e.keyCode === 13){
        this.createFolder()
      }
    },
    handleChange(x) {
      if (this.files.length > 0) this.readyToUpload = true
      else this.readyToUpload = false
    },
    async uploadPhotos() {
      this.uploading = true
      this.showUpload = false
      this.readyToUpload = false
      await this.$store.dispatch("setExecuting", true)
      let g = null
      if (!this.systemImages) {
        g = this.currentGroup.vanityPath
      }
      this.gotError = false
      const reduce = require('image-blob-reduce')();
      for (let image of this.files) {
        if (!this.gotError) {
          if (image.size >= 2000000) {
            await reduce.toBlob(image, {max: 2000})
              .then(blob => {
                image.file = blob
                console.log("Reduced image....", image);
              })
          }
          let results = await api.generalUploadImage(this.currentFolder.id, g, image)
          if (results.success) {
              let img = results.image
              try {
                let urlCreator = window.URL || window.webkitURL
                img.thumb = urlCreator.createObjectURL(image)
              } catch (error) {
                console.error("Couldn't use uploaded blob as img.")
              }
              this.images.unshift(img)
            }
            else {
              this.gotError = true
              this.showUpload = true
              this.$notify.error({message: error.response.data, timeOut: 5000})
              this.$store.dispatch("setExecuting", false)
            }
            this.uploading = false
        }
      }
      this.files = []
      await this.$store.dispatch("setExecuting", false)
    },

    moveToFolder: function (folder) {
      this.showMoveFolder = false
      let url
      if (this.moveCandidates.length > 0) url = "/image/move/"
      else url = "/imageFolder/move/" + this.currentFolder.id
      this.$store.dispatch("setExecuting", true)
      api.post(url, {folder: folder, candidates: this.moveCandidates}).then(
        (details) => {
          if (this.moveCandidates.length > 0) {
            let message = "Image moved to " + (folder ? folder.name : "Top")
            if (this.moveCandidates.length > 1) message = this.moveCandidates.length + " images moved to " + (folder ? folder.name : "Top")
            this.$notify.success({message: message, timeOut: 3000})
            this.moveCandidates = []
          }
          this.loadFolders(this.currentFolder)
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    moveAllSelected: function () {
      this.showMoveFolder = true
      this.moveCandidates = []
      for (let i of this.images) {
        if (i.selected) this.moveCandidates.push(i)
      }

    },
    moveFolder: function () {
      this.showMoveFolder = true
      this.moveCandidate = []
    },
    renameFolder: function () {
      if (!this.newFolderName || !this.newFolderName.trim()) {
        this.$notify.error({message: "Folder name cannot be empty."})
        return
      }
      this.$store.dispatch("setExecuting", true)
      api.post("/imageFolder/rename/" + this.currentFolder.id, {name: this.newFolderName}).then(
        (details) => {
          this.currentFolder.name = this.newFolderName
          this.breadcrumbs[this.breadcrumbs.length - 1].name = this.newFolderName
          this.newFolderName = ""
          this.renameModal = false
        },
        (error) => {
          this.$notify.error({message: "Error renaming folder"})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editMeta: function(img) {
      this.$store.dispatch("setExecuting", true)
      api.get("/image/meta/" +img.id).then(
        (details) => {
          this.workingMeta = details.data
          this.showMetaModal = true
        },
        (error) => {
          this.$notify.error({message: "Could not get meta data to edit."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    saveMeta: function() {
      this.showMetaModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/image/meta/" + this.workingMeta.id, this.workingMeta).then(
        () => {
          this.workingMeta = null
        },
        (error) => {
          this.showMetaModal = true
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    createFolder: function () {
      if (!this.newFolderName || !this.newFolderName.trim()) {
        this.$notify.error({message: "Folder name cannot be empty."})
        return
      }
      this.$store.dispatch("setExecuting", true)
      let url = "/imageFolder/create/"
      if (!this.systemImages) url += this.currentGroup.vanityPath
      api.put( url, {
        name: this.newFolderName,
        folder: this.currentFolder
      }).then(
        (details) => {
          this.folders.unshift(details.data)
          this.newFolderName = ""
          this.createModal = false
        },
        (error) => {
          this.$notify.error({message: "Error creating folder"})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteFolder: function () {
      this.$store.dispatch("setExecuting", true)
      api.delete("/imageFolder/delete/" + this.currentFolder.id).then(
        (details) => {
          let loc = this.folders.indexOf(this.currentFolder)
          this.currentFolder = null
          if (this.breadcrumbs.length <= 2) this.loadFolders(null)
          else this.loadFolders(this.breadcrumbs[this.breadcrumbs.length - 2])
        },
        (error) => {
          this.$notify.error({message: "Error deleting folder"})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    navTop: function () {
      this.currentFolder = null
    },
    deleteSelected: function () {
      this.showDeleteModal = true
    },
    doDeleteSelected: function () {
      this.showDeleteModal = false
      let deleteCandidates = []
      for (let i of this.images) {
        if (i.selected) deleteCandidates.push(i.id)
      }
      this.$store.dispatch("setExecuting", true)
      let url = "/image/groupImageDelete/"
      if (this.systemImages) url = "/image/systemImageDelete"
      api.post(url, deleteCandidates).then(
        (details) => {
          this.loadFolders(this.currentFolder)
          this.$notify.success({message: "Moved to trash folder!.", timeOut: 5000})

        },
        (error) => {
          this.$notify.error({message: "Error deleting photo."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleSlideshow: function (image) {
      api.get("/image/toggleSlideshow/" + image.id, {}).then(
        (details) => {
          image.includeInSlideshow = !image.includeInSlideshow
        },
        (error) => {
          this.$notify.error({message: "Error editing slideshow."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    togglePublicAccess: function (image) {
      api.get("/imageFolder/togglePublicListing/" + this.currentFolder.id, {}).then(
        (details) => {
          this.currentFolder.allowPublicListing = details.data.allowPublicListing
          console.log("Data is ", details)
        },
        (error) => {
          this.$notify.error({message: "Error toggling public access."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    makeAvatar: function (image) {
      api.get("/group/setAvatar/" + this.$route.params.id + "?image=" + image.id, {}).then(
        (details) => {
          this.currentGroup.avatarId = image.id
          this.currentGroup.avatar = image.thumb
        },
        (error) => {
          this.$notify.error({message: "Error setting avatar."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }
};

</script>
<style scoped>
.no-padding {
  padding: 0 !important;
}

.top-actions {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ffffff;
  opacity: 0.9;
}



</style>


